import {
  SET_ORDER_STATUS_FROM_GOC,
  SET_ORDER_STATUS_FROM_ORDER_SUMMARY,
  SET_ORDER_STATUS_FROM_TRACKING_EVENTS,
  SET_ORDER_STATUS_TO_STORE,
} from '../actions';

interface StatusesState {
  orderStatusFromGOC: string;
  orderStatusFromOrderSummary: string;
  orderStatusFromTrackingEvents: string;
  orderStatus: string;
}

interface Action {
  type: string;
  payload?: Partial<StatusesState>;
}

const initialState: StatusesState = {
  orderStatusFromGOC: '',
  orderStatusFromOrderSummary: '',
  orderStatusFromTrackingEvents: '',
  orderStatus: '',
};

export const statuses = (state: StatusesState = initialState, { type, payload }: Action): StatusesState => {
  switch (type) {
    case SET_ORDER_STATUS_FROM_GOC:
    case SET_ORDER_STATUS_FROM_ORDER_SUMMARY:
    case SET_ORDER_STATUS_FROM_TRACKING_EVENTS:
    case SET_ORDER_STATUS_TO_STORE:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};
